const commonHelper = require('./common-helper');
const config = require('../config');
const { CouponTypes, DeliveryWay } = require('../helper/const');
const Immutable = require('seamless-immutable');

import { formatMessage } from '../intl/helper';
import globalMessages from '../intl/messages/global';
import couponMessages from '../intl/messages/coupon';
import orderMessages from '../intl/messages/order';

exports.filterCouponListByStatus = (couponList, status) => couponList.filter(item => item.coupInstanceBean.couponStatus === status);

exports.formatDate = date => {
  const replaceStr = '-';
  if (date) {
    return date
      .toString()
      .replace(new RegExp(replaceStr, 'gm'), '/')
      .substring(0, 10);
  }
  return false;
};

exports.formatOriginDate = date => {
  function appendZero(obj) {
    if (obj < 10) return `0${obj}`;
    return obj;
  }

  if (date) {
    const time = new Date(date);
    const getFullYear = time.getFullYear();
    const getMonth = time.getMonth() + 1;
    const getDate = time.getDate();
    return `${getFullYear}/${appendZero(getMonth)}/${appendZero(getDate)}`;
  }
  return false;
};

const formatInstruction = (exports.formatInstruction = information => {
  if (information) {
    return information
      .replace(/<\/(h[1-6]|p|li)>/g, '</$1>\n')
      .replace(/<\/?.+?>/g, '')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&nbsp;/g, '')
      .trim()
      .split('\n');
  }
  return '';
});

const formatWeixinTime = (exports.formatWeixinTime = advancedInfo => {
  function appendZero(obj) {
    if (obj < 10) return `0${obj}`;
    return obj;
  }
  if (advancedInfo.timeLimit && advancedInfo.timeLimit.length !== 0) {
    return advancedInfo.timeLimit.map((item, index) => {
      let day = '';
      switch (item.type) {
        case 'SUNDAY':
          day = formatMessage(globalMessages.sunday);
          break;
        case 'MONDAY':
          day = formatMessage(globalMessages.monday);
          break;
        case 'TUESDAY':
          day = formatMessage(globalMessages.tuesday);
          break;
        case 'WEDNESDAY':
          day = formatMessage(globalMessages.wednesday);
          break;
        case 'THURSDAY':
          day = formatMessage(globalMessages.thursday);
          break;
        case 'FRIDAY':
          day = formatMessage(globalMessages.friday);
          break;
        case 'SATURDAY':
          day = formatMessage(globalMessages.saturday);
          break;
        default:
          day = item.type;
          break;
      }

      return `${day} ${appendZero(item.beginHour)}:${appendZero(item.beginMinute)} ~ ${appendZero(item.endHour)}:${appendZero(item.endMinute)} \n`;
    });
  }
  return false;
});

const getCouponRuleVale = (exports.getCouponRuleVale = (couponType, itemInner) => {
  if (itemInner.ruleName === 'offerValue' || itemInner.ruleName === 'zkValue' || itemInner.ruleName === 'giftName' || itemInner.ruleName === 'faceValue') {
    return itemInner.ruleValue || '--';
  }
  return false;
});

// weixin优惠券参数设置
exports.weixinCouponParam = item => {
  let ruleVale = '';
  let typeClass = '';
  let typeUnit = '';
  let statusWord = '';
  const couponName = item.couponName;
  let couponTypeName = '';
  let fullValue = '';
  let instructions = '';
  const codeNumber = item.code;
  const periodStart = item.beginDate ? item.beginDate.substring(0, 5) || '00:00' : '00:00';
  const periodEnd = item.endDate ? item.endDate.substring(0, 5) || '00:00' : '00:00';
  const giftFontStyle = {};
  const { extraPeriodStart, extraPeriodEnd } = item;

  switch (item.card.cardType) {
    case 'DISCOUNT':
      typeClass = 'zhekou';
      typeUnit = formatMessage(globalMessages.discount);
      couponTypeName = formatMessage(couponMessages.zhekouCoupon);
      instructions = [formatInstruction(item.card.discount.baseInfo.description), formatWeixinTime(item.card.discount.advancedInfo)];
      fullValue = item.card.discount.leastCost || 0;
      ruleVale = ((100 - item.card.discount.discount) / 10).toFixed(1);
      break;
    case 'CASH':
      typeClass = 'xianjin';
      typeUnit = sessionStorage.getItem('currency');
      couponTypeName = formatMessage(couponMessages.daijinCoupon);
      instructions = [formatInstruction(item.card.cash.baseInfo.description), formatWeixinTime(item.card.cash.advancedInfo)];
      fullValue = item.card.cash.leastCost || 0;
      ruleVale = item.card.cash.reduceCost.toString() || '';
      break;
    default:
      break;
  }

  statusWord = formatMessage(globalMessages.validityPeriod);

  return {
    typeClass,
    giftFontStyle,
    typeUnit,
    ruleVale,
    fullValue,
    statusWord,
    codeNumber,
    instructions,
    couponName,
    couponTypeName,
    periodStart,
    periodEnd,
    extraPeriodStart,
    extraPeriodEnd,
  };
};

// loyalty优惠券参数设置

exports.loyaltyCouponParam = item => {
  let ruleVale = '';
  let typeClass = '';
  let typeUnit = '';
  let giftUnitBefore = '';
  let giftFontSize = '';
  let giftVerticalAlign = '';
  let giftLineHeight = '';
  let statusWord = '';
  let deliveryWay = '';
  const couponName = item.couponName;
  let couponTypeName = '';
  let giftFontStyle = {};
  const fullValue = item.fullValue;
  const delivery = item.delivery;
  const codeNumber = item.codeNumber;
  const renderWeek = commonHelper.renderDay(item.week);
  const periodStart = item.periodStart ? item.periodStart.substring(0, 5) || '00:00' : '00:00';
  const periodEnd = item.periodEnd ? item.periodEnd.substring(0, 5) || '00:00' : '00:00';
  const couponType = item.couponType;
  const { extraPeriodStart, extraPeriodEnd } = item;
  const instructions = [].concat(formatInstruction(item.instructions));

  if (renderWeek) {
    instructions.push(formatMessage(globalMessages.conditionEnable, { condition: renderWeek.substring(0, renderWeek.length - 1) }));
  } else {
    /* instructions.push('整周可用');*/
  }

  // 配送方式
  switch (delivery) {
    case DeliveryWay.ALL:
      deliveryWay = `${formatMessage(couponMessages.distributionMode)}${formatMessage(couponMessages.send)},${formatMessage(couponMessages.self)}`;
      break;
    case DeliveryWay.SEND:
      deliveryWay = `${formatMessage(couponMessages.distributionMode)}${formatMessage(couponMessages.send)}`;
      break;
    case DeliveryWay.SELF:
      deliveryWay = `${formatMessage(couponMessages.distributionMode)}${formatMessage(couponMessages.self)}`;
      break;
    default:
      break;
  }

  // 本券部分门店可用
  let desc = `${formatMessage(couponMessages.thisCoupon)}${formatMessage(couponMessages.couponAvailableInSomeStores)}`;

  if (item.allCommercial) {
    // true=全部门店可用 false=部分门店可用
    // 本券全部门店可用
    desc = `${formatMessage(couponMessages.thisCoupon)}${formatMessage(couponMessages.couponAvailableInAllStores)}`;
  }

  instructions.push({
    desc,
    usableShop: item.usableCommercialDesc,
    showUsableBtn: !item.allCommercial,
  });

  item.coupRuleBeanList.forEach((itemInner, indexInner) => {
    const vale = getCouponRuleVale(item.couponType, itemInner);
    if (vale) {
      ruleVale = vale;
    }
  });
  switch (item.couponType) {
    case CouponTypes.OFFERVALUE:
      typeClass = 'manjian';
      typeUnit = sessionStorage.getItem('currency');
      couponTypeName = formatMessage(couponMessages.manjianCoupon);
      break;
    case CouponTypes.ZKVALUE:
      typeClass = 'zhekou';
      typeUnit = formatMessage(globalMessages.discount);
      couponTypeName = formatMessage(couponMessages.zhekouCoupon);
      break;
    case CouponTypes.GIFTVALUE:
      typeClass = 'lipin';
      giftUnitBefore = formatMessage(orderMessages.orderGift);
      couponTypeName = item.coupDishBeanList.length ? formatMessage(couponMessages.cplipinCoupon) : formatMessage(couponMessages.ptlipinCoupon);
      giftFontSize = '1.2em';
      giftVerticalAlign = '0px';
      giftLineHeight = '1.2em';
      giftFontStyle = { fontSize: giftFontSize, verticalAlign: giftVerticalAlign, lineHeight: giftLineHeight };
      break;
    case CouponTypes.FACEVALUE:
      typeClass = 'xianjin';
      typeUnit = sessionStorage.getItem('currency');
      couponTypeName = formatMessage(couponMessages.daijinCoupon);
      break;
    default:
      break;
  }

  if (item.couponStatus !== 1) {
    if (item.couponStatus === 3) {
      typeClass = 'shixiao yiguoqi';
    } else {
      typeClass = 'shixiao yishiyong';
    }
  }

  statusWord = formatMessage(globalMessages.validityPeriod);

  return {
    typeClass,
    giftFontStyle,
    giftUnitBefore,
    typeUnit,
    ruleVale,
    fullValue,
    periodStart,
    periodEnd,
    extraPeriodStart,
    extraPeriodEnd,
    statusWord,
    codeNumber,
    instructions,
    couponName,
    couponTypeName,
    couponType,
    deliveryWay,
  };
};

exports.getShareCouponPageUrl = args => {
  const url = `${config.apiBase}/coupon/getShareCouponPage?${commonHelper.formatObjToParamStr(args)}`;
  return url;
};

exports.getShareCouponImageUrl = args => {
  const url = `${config.apiBase}/images/common/share_icon.png`;
  return url;
};

exports.getUseCouponsId = coupons => {
  const couponItem = Immutable.from(coupons).asMutable({ deep: true }) || [];
  const useCoupons = [];

  couponItem.forEach(prop => {
    useCoupons.push(prop.id);
  });

  return useCoupons;
};



// WEBPACK FOOTER //
// ./src/helper/coupon-helper.js